<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.189"
    height="19.797"
    viewBox="0 0 20.189 19.797"
  >
    <g transform="translate(0 -4.952)">
      <path
        d="M16.6,16.234h-.923a4.106,4.106,0,0,1-2.285-.692l-.805-.537a2.926,2.926,0,0,1-1.306-2.44V6.729A1.779,1.779,0,0,0,9.5,4.952H1.188V9.5h.594v2.711a3.911,3.911,0,0,1-.557,2.012L.553,15.346a3.882,3.882,0,0,0-.553,2v7.4H6.532v-.728l5.327.548a17.677,17.677,0,0,0,2.547.183,17.873,17.873,0,0,0,5.368-.823l.415-.131V19.822A3.592,3.592,0,0,0,16.6,16.234ZM2.375,6.14H6.532V7.821a.5.5,0,0,1-.5.5H2.375Zm-1.188,11.2a2.7,2.7,0,0,1,.384-1.386l.671-1.118a5.1,5.1,0,0,0,.726-2.623V9.5H6.036A1.685,1.685,0,0,0,7.719,7.821V6.14H9.5a.59.59,0,0,1,.59.59v.6H8.907V8.515h1.188V9.7H8.907V10.89h1.188v1.188H8.907v1.188h1.247a4.108,4.108,0,0,0,.354,1.1l-1.145.783.671.98,1.142-.782a4.131,4.131,0,0,0,.753.645l.258.172-.628,1.093,1.03.592.6-1.048a5.286,5.286,0,0,0,2.487.619H16.6a2.4,2.4,0,0,1,2.4,2.4v.721a16.7,16.7,0,0,1-6.983.47l-4.256-.623H1.188Zm10.831,6.046L5.344,22.7v.856H1.188V21.578H7.676l4.17.61a17.677,17.677,0,0,0,2.559.185,17.921,17.921,0,0,0,4.6-.6v1.144a16.7,16.7,0,0,1-6.983.47Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
